import { makeStyles, shorthands } from "@fluentui/react-components";

const useAvailableQuoteFeedsStyles = makeStyles({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("12px"),
  },

  updateButton: {
    alignSelf: "flex-end",
  },
});

export default useAvailableQuoteFeedsStyles;
